<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BlujayBcaUserLocationIndex",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  